/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
  },
}));

const Complete = () => {
  const classes = useStyles();

  return (
    <div>
      <h4 className={classes.title}>
        Your Neuralert wrist monitor was successfully added. You may now close Tera Term completely and unplug your
        monitor, replacing the 3-pronged cover back onto the UART-USB cable.
      </h4>
      <h4 className={classes.title}>Place battery back into monitor and power it back on.</h4>
      <h4 className={classes.title}>
        Insert the battery and circuit board back into the casing and screw the back on.
      </h4>
      <h4 className={classes.title}>Click DONE to complete monitor setup and navigate to the Monitors screen.</h4>
    </div>
  );
};

export default Complete;
